<template>
  <v-flex>
    <v-flex xs12 class="pb-2">
      <h2 class="primary--text pb-2">Tasks</h2>
      <v-layout row style="position:relative">
        <p>Create or edit the tasklists templates and tasks for a case type. You can drag and drop to re-order Tasklists and Tasks.</p>

      </v-layout>
    </v-flex>
    <tasklist-template-list v-on:tasklist-remove="removeTasklist"></tasklist-template-list>
    <v-btn
      v-show="addTasklistButton"
      v-on:click="addTasklistForm = true; addTasklistButton = false"
      class="ml-0"
      color="secondary"
      style="float:left;">
      Add a tasklist
    </v-btn>
      <form v-show="addTasklistForm" @submit="addTasklist()">
      <v-layout wrap row class="pa-4 ml-0" style="background:rgb(240, 240, 240);">
        <v-flex xs12 sm6>
          <v-text-field v-model="newTasklistName" :error="isNewTasklistEmpty" label="New tasklist name" class="white-box-field" box></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-btn class="ml-0" color="success" @click="addTasklist()">Confirm Tasklist</v-btn>
          <v-btn
            color="error"
            v-on:click="addTasklistForm = false; addTasklistButton = true">
            Cancel
          </v-btn>
        </v-flex>
      </v-layout>
    </form>
    <br><br><br>
  </v-flex>
</template>

<script>
import TasklistTemplateList from '@/components/cases/case-config/TasklistTemplateList'

export default {
  name: "case-config-tasks",
  components: { TasklistTemplateList },
  props: { caseType: { type: Object, required: true } },
  data: () => {
    return {
      addTaskButton: true,
      addTaskForm: false,
      addTasklistButton: true,
      addTasklistForm: false,
      tasklistTitle: true,
      tasklistTitleEdit: false,
      newTasklistName: "",
      isNewTasklistEmpty: false,
      hideDragIcon: false
    }
  },
  watch: {
    hideDragIcon() {
      this.$store.commit("toggleDragIcons", this.hideDragIcon)
    },
    newTasklistName() {
      if (this.newTasklistName !== "" && this.isNewTasklistEmpty) { this.isNewTasklistEmpty = false }
    }
  },
  computed: {
    tasklistTemplates() {
      if (this.caseType && this.caseType.tasklistTemplates) {
        return this.orderTasklists()
      } else {
        return []
      }
    }
  },
  methods: {
    orderTasklists() {
      if (this.caseType && this.caseType.tasklistTemplates) {
        return this.caseType.tasklistTemplates.sort(function (a, b) {
          if (a.position < b.position) { return -1 }
          if (a.position > b.position) { return 1 }
          return 0
        })
      }
    },
    async addTasklist() {
      if (!this.tasklistTemplates) { this.tasklistTemplates = [] }
      if (this.newTasklistName !== "") {
        const result = await this.$store.dispatch("createTasklistTemplate", { caseTypeId: this.caseType.id, name: this.newTasklistName, position: this.tasklistTemplates.length })
        if (!result.error) {
          this.tasklistTemplates.push({ id: result.id, name: this.newTasklistName, tasks: [] })
          this.newTasklistName = ""
          this.addTasklistForm = false
          this.addTasklistButton = true
        } else {
          this.isNewTasklistEmpty = true
        }
      } else {
        this.isNewTasklistEmpty = true
      }
    },
    async removeTasklist(tasklist) {
      const result = await this.$store.dispatch("deleteTasklistTemplate", tasklist.id)
      if (!result.error) {
        const index = this.caseType.tasklistTemplates.indexOf(tasklist)
        if (index >= 0) this.caseType.tasklistTemplates.splice(index, 1)
      }
    }
  }
}
</script>

<style stylus>
.tasklist-task .v-expansion-panel__header__icon {
  display: none !important;
}

.tasklist-task .v-expansion-panel__header h3 {
  position: relative;
}

.accordion-parent
  .accordion-child
  .v-expansion-panel.tasklist-task
  .v-expansion-panel__header {
  padding-left: 0px !important;
}

.tasklist-task .v-expansion-panel__header h3:after {
  content: "...";
  position: absolute;
  top: 0px;
  right: -13px;
  transition: all 0.3s ease;
}

.tasklist-task .v-expansion-panel__header:hover h3:after {
  letter-spacing: 3px;
  top: 0px;
  right: -22px;
  transition: all 0.3s ease;
}
</style>
